import { Component, OnInit } from '@angular/core';
import { serverDateMillis } from '../shared/date.util';
import { DeviceService, Device } from '../../Device-Service/device.service';
import { formatDistanceToNow } from 'date-fns';
import { utcToZonedTime, format } from 'date-fns-tz';
import { de } from 'date-fns/locale';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.css']
})
export class DeviceListComponent implements OnInit {
  devices: Device[] = [];
  private intervalId: any;

  constructor(private deviceService: DeviceService) { }

  ngOnInit(): void {
    this.loadDevices();

    this.intervalId = setInterval(() => {
      this.loadDevices();
    }, 5000); // 5000 ms = 5 Sekunden

  }

  ngOnDestroy(): void {
    // Intervall stoppen, wenn die Komponente zerstört wird
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  loadDevices(): void {
    this.deviceService.getDevices().subscribe((data) => {
      this.devices = data;
    });
  }

  // Prüfen, ob das Gerät online ist (LifeBit innerhalb von 1 Minute)
  isOnline(lastLifeBit: string): boolean {
    // Vorher wurde 'Z' an ein Date-OBJEKT gehängt statt an die Zeichenkette.
    // Das ergab ein ungültiges Datum, die Differenz war NaN – und damit galt
    // jedes Gerät als offline.
    const utcDate = serverDateMillis(lastLifeBit);
    if (isNaN(utcDate)) {
      return false;
    }

    const currentTime = Date.now();

    return (currentTime - utcDate) / 1000 <= 180; // Unterschied in Sekunden
  }

  formatDate(lastLifeBit: string): number {
    const utcDate = serverDateMillis(lastLifeBit);
    if (isNaN(utcDate)) {
      return 0;
    }

    const currentTime = Date.now(); // Aktueller Zeitstempel in Millisekunden

    // Differenz in Millisekunden -> Umwandeln in Minuten
    return Math.floor((currentTime - utcDate) / (1000 * 60));
  }


}
